import Api from './base';
import fetch from 'isomorphic-fetch';
import config from '../configs/appConfig';

export default class UserApi extends Api {
  userLogin(email, password) {
    return this.request('POST', `${this.baseUrl}/api/1.0/login`, { email, password }, this.headers);
  }

  userRegister(username, email, password, confirmPassword) {
    return this.request(
      'POST',
      `${this.baseUrl}/api/1.0/register`,
      { username, email, password, confirmPassword },
      this.headers
    );
  }

  userSocialLogin({ email, avatarUrl, firstName, lastName }) {
    return this.request(
      'POST',
      `${this.baseUrl}/api/1.0/social`,
      { email, avatarUrl, firstName, lastName },
      this.headers
    );
  }

  getUserStreamToken(userId) {
    return this.request('GET', `${this.baseUrl}/api/1.0/token?userId=${userId}`, null, this.headers);
  }

  followUser(userId, followerId) {
    return this.request('POST', `${this.baseUrl}/api/1.0/user/${userId}/follow`, { followerId }, this.headers);
  }

  unfollowUser(userId, followerId) {
    return this.request('POST', `${this.baseUrl}/api/1.0/user/${userId}/unfollow`, { followerId }, this.headers);
  }

  getUserDetails(userId) {
    return this.request('GET', `${this.baseUrl}/api/1.0/user/${userId}`, null, this.headers);
  }

  updateUserCategories(userId, email, categories) {
    return this.request(
      'POST',
      `${this.baseUrl}/api/1.0/user/${userId}/categories`,
      { email, categories },
      this.headers
    );
  }

  getUsersLocation(ipAddress) {
    return fetch(`https://api.ipstack.com/${ipAddress}?access_key=${config.location.apiKey}&format=1`);
  }

  getUsersIpAddress() {
    return fetch('https://api.ipify.org?format=json');
  }
}
